<div class="p-grid ">
    <div class="p-col-10 m-auto p-mt-5">
        <div class="p-grid">
            <p-card class="p-xl-4 p-lg-4 p-md-12 p-sm-12 cont" header="">
                <div class="p-lg-12 text-center">
                    <img src="assets/imagenes/splash-carga-y-descarga.jpg" alt="" class="img-fluid">
                </div>
                <div class="ui-card-title">{{'OBJETIVO.DUM.TITULO' | translate}}</div>
                <p>
                    {{'OBJETIVO.DUM.TEXTO1' | translate}}
                </p>
                <p>
                    {{'OBJETIVO.DUM.TEXTO2' | translate}}
                </p>
                <p class="npb">
                    {{'OBJETIVO.DUM.TEXTO3' | translate}}
                </p>
            </p-card>
            <p-card class="p-xl-4 p-lg-4 p-md-12 p-sm-12 cont" header="">
                <div class="p-lg-12 text-center">
                    <img src="assets/imagenes/splass-pmr-new.png" alt="" class="img-fluid">
                </div>
                <div class="ui-card-title">{{'OBJETIVO.PMR.TITULO' | translate}}</div>
                <p>
                    {{'OBJETIVO.PMR.TEXTO1' | translate}}
                </p>
                <p>
                    {{'OBJETIVO.PMR.TEXTO2' | translate}}
                </p>
                <p class="npb">
                    {{'OBJETIVO.PMR.TEXTO3' | translate}}
                </p>
            </p-card>
            <p-card class="p-xl-4 p-lg-4 p-md-12 p-sm-12 cont" header="">
                <div class="p-lg-12 text-center">
                    <img src="assets/imagenes/splash-electrico.jpg" alt="" class="img-fluid">
                </div>
                <div class="ui-card-title">{{'OBJETIVO.ELECTRICO.TITULO' | translate}}</div>
                <p>
                    {{'OBJETIVO.ELECTRICO.TEXTO1' | translate}}
                </p>
                <p class="npb">
                    {{'OBJETIVO.ELECTRICO.TEXTO2' | translate}}
                </p>
            </p-card>
        </div>
    </div>
</div>